var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdd = function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "currentColor",
    style: {
      color: "#3b7cc9"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.333 0C.597 0 0 .672 0 1.5v9c0 .828.597 1.5 1.333 1.5h9.334c.736 0 1.333-.672 1.333-1.5v-9c0-.828-.597-1.5-1.333-1.5H1.333ZM5.93 1.709c.344 0 .623.278.623.622l.003 2.898 2.898-.002a.622.622 0 1 1 .001 1.245l-2.898.002.002 2.899a.622.622 0 1 1-1.244 0l-.003-2.898-2.899.003a.622.622 0 1 1 0-1.245L5.31 5.23l-.003-2.898c0-.344.279-.623.622-.623Z",
    clipRule: "evenodd"
  })));
};
export default SvgAdd;